module.exports = __webpack_public_path__ + "static/3-4675ab8c6675852061355a6fd527db35.png";